import styled from 'styled-components';

// Wrapper principal
export const Wrapper = styled.div`
  width: 100%;
  background-color: #fff;
`;

// Container interno
export const Container = styled.div`
  padding: 2rem;
  max-width: 1400px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

// Seção de título e subtítulo
export const HeaderSection = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;


`;

export const Title = styled.h2`
  font-size: 3.75rem;
  font-weight: bold;
  color: #6b7280;

  @media (max-width: 678px) {
    font-size: 2.5rem;
   
  }
`;

export const Highlight = styled.span`
  color: #ec4899;
`;

export const Subtitle = styled.p`
  font-size: 1rem;
  color: #9ca3af;
  max-width: 700px;
  margin: 0 auto;
`;

// Grid de estatísticas
export const StatsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1.5rem;
  margin-top: 2rem;
  @media (max-width: 640px) {
    grid-template-columns: 1fr; /* todas em uma única coluna */
  }
`;

export const StatCard = styled.div`
  background-color: white;
  border-radius: 1rem;
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-shadow: 0 10px 15px rgba(0,0,0,0.05);
`;

export const StatIconCard = styled.div`
  font-size: 2rem;
  margin-bottom: 0.5rem;
`;

export const StatNumber = styled.div`
  font-size: 1.5rem;
  font-weight: bold;
  color: #374151;
  text-align: center;
  margin-bottom: 0.5rem;
`;

export const StatLabel = styled.div`
  font-size: 0.875rem;
  color: #6b7280;
  text-align: center;
`;

export const StatImageGrid = styled.img`
  width: 100%;
  height: 100%;
  object-fit: ;
  border-radius: 1rem;
`;

export const StatImage = styled.img` 
  width: 100%; 
  height: 100%; 
  object-fit: contain; 
  border-radius: 1rem; 
`;


// Gallery
// Solução com grid aninhado para diferentes proporções por linha
export const GalleryGrid = styled.div`
  display: grid;
  grid-template-columns: 3fr 5fr;
  grid-template-rows: 400px 300px;
  gap: 1rem;
  margin-top: 2rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    grid-template-rows: auto;
  }
`;

export const LargeImage = styled.div`
  grid-row: 1 / 3;
  position: relative;
  border-radius: 1rem;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  @media (max-width: 768px) {
    grid-row: auto; /* deixa ocupar apenas 1 linha */
    height: 250px;  /* ajuste para mobile */
  }
`;

export const TopRow = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 1rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 0.75rem;
  }
`;

export const BottomRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 0.75rem;
  }
`;

export const SmallImage = styled.div`
  position: relative;
  border-radius: 1rem;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  @media (max-width: 768px) {
    height: 180px; /* ajuste de altura para mobile */
  }
`;


export const TextCard = styled.div`
  background-color: #1f4f5f;
  display: flex;
  align-items: center;
  justify-content: start;
  border-radius: 1rem;
  padding: 1rem;


`;

export const GradientCard = styled(TextCard)`
  background: linear-gradient(135deg, #D82E88 0%, #40909F 100%);
`;

export const TextCardContent = styled.p`
  color: white;
  font-weight: 600;
  margin: 0;
  font-size: 1.5rem;
  line-height: 1.4;
  width: 90%;

  @media (max-width: 768px) {
    font-size: 1.25rem;
  }
`;

export const TextCardContentBottom = styled(TextCardContent)`
  font-size: 1.5rem;

  @media (max-width: 768px) {
    font-size: 1.25rem;
  }
`


// CTA
export const CtaSection = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  margin-top: 2rem;
`;

export const PrimaryButton = styled.button`
  background: linear-gradient(90deg, #5E287E 0%, #D82E88 100%);
  color: white;
  padding: 1rem 2rem;
  border-radius: 9999px;
  font-weight: 600;
  font-size: 1rem;
  cursor: pointer;
  border: none;
`;

export const FreeText = styled.div`
  color: #ec4899;
  font-size: 0.875rem;
`;
